import { handleError } from '~/ErrorHandler';
import { fetchMoreGroupProductHistory } from '~/GroupProductHistory';
import { ThunkAction } from '~/Store';

export function fetch(groupId: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		try {
			await dispatch(fetchMoreGroupProductHistory(groupId));
		} catch (error) {
			dispatch(handleError(error));
		}
	};
}
